import React from 'react'
import styled from 'styled-components'
import FiltersForm from './FiltersForm'
import { Results } from './Results'
import useMediaQuery from '../../../hooks/useMediaQuery'

const HistorySellsOrdersPage = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr;
  overflow-y: hidden;
  min-height: 0;
`

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: .5rem;
  padding: .5rem 1rem 0;
`

const Collapsible = styled.div<{ open: boolean }>`
  display: ${p => (p.open ? 'block' : 'none')};
`;

function HistorySellOrders() {
  const [results, setResults] = React.useState<any[] | null>(null);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [filtersOpen, setFiltersOpen] = React.useState(true);

  const handleSetResults = (data: any[]) => {
    setResults(data);
    if (isMobile) setFiltersOpen(false);
  }

  return (
    <>
      <HistorySellsOrdersPage>
        <TopBar>
          <button className='btn btn-outline-secondary btn-sm' onClick={() => setFiltersOpen(s => !s)}>
            {filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'}
          </button>
        </TopBar>
        <Collapsible open={filtersOpen}>
          <FiltersForm setData={handleSetResults}></FiltersForm>
        </Collapsible>
        <Results data={results}></Results>
      </HistorySellsOrdersPage>
    </>
  )
}

export default HistorySellOrders